import React, { useState } from "react";

import {
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  UncontrolledAlert,
} from "reactstrap";

import brand from "../../../assets/img/logo.png";

import { useAuth } from "../../../providers/authProvider";
import { authApi } from "../../../services/authServices";
import Loader from "../../../components/Loader";
import TwoFAForm from "../../../components/auth/TwoFAForm";
import TwoFASetupModal from "../../../components/auth/TwoFASetupModal";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export const LoginForm = () => {
  const [, setAuthContext] = useAuth();

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [twoFAData, setTwoFAData] = useState(null);

  const onDismiss = () => setError(false);

  const doLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(false);
    try {
      const result = await authApi.login({ email, password });
      if (!result) {
        setLoading(false);
        return null;
      }
      setAuthContext({ currentUser: result });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const data = err.response?.data;
      if (data?.twoFABlock) {
        setTwoFAData(data);
        return;
      }
      setError(data?.message || "There was an error, please try again.");
    }
    return false;
  };

  const on2FAComplete = (result) => {
    setTwoFAData(null);
    setAuthContext({ currentUser: result });
  };

  const onBack2FA = () => {
    setTwoFAData(null);
  };

  if (twoFAData?.twoFAForced) {
    return (
      <TwoFASetupModal
        userId={twoFAData.userId}
        defaultTwoFASetup={{
          qrcode: twoFAData.qrcode,
          secret: twoFAData.secret,
        }}
        onClose={onBack2FA}
        onSubmit={on2FAComplete}
      />
    );
  }

  return (
    <React.Fragment>
      <div className="text-center mt-4">
        <h2>Welcome back!</h2>
        <p className="lead">Sign in to your account to continue</p>
      </div>
      <Card>
        <CardBody>
          <div className="m-sm-4">
            <div className="text-center">
              <img
                src={brand}
                className="rounded p-0 col-8 my-4"
                alt={"Ben Parker"}
              />
            </div>
            {twoFAData ? (
              <TwoFAForm
                message={twoFAData.message}
                userId={twoFAData.userId}
                onComplete={on2FAComplete}
                onBack={onBack2FA}
              />
            ) : (
              <Form onSubmit={doLogin}>
                <FormGroup>
                  <Label>Email</Label>
                  <Input
                    maxLength="50"
                    required={true}
                    bsSize="lg"
                    name="email"
                    className="mb-1"
                    type="email"
                    placeholder="Enter your email"
                    onChange={(event) =>
                      setEmail(event.currentTarget.value.trim())
                    }
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Password</Label>
                  <Input
                    id="passwordUser"
                    required={true}
                    maxLength="50"
                    bsSize="lg"
                    type="password"
                    name="password"
                    placeholder="Enter your password"
                    onChange={(event) => setPassword(event.currentTarget.value)}
                  />
                  <small>
                    <Link to="/auth/reset">Forgot password?</Link>
                  </small>
                </FormGroup>
                <div className="text-center mt-3">
                  <UncontrolledAlert
                    isOpen={!!error}
                    toggle={onDismiss}
                    color="warning"
                  >
                    <div className="alert-icon">
                      <FontAwesomeIcon icon={faBell} fixedWidth />
                    </div>
                    <div className="alert-message text-left">
                      <span className="ml-2">{error}</span>
                    </div>
                  </UncontrolledAlert>
                  {loading ? (
                    <Loader size="sm" />
                  ) : (
                    <Button id="signIn" color="primary" type="submit" size="lg">
                      Sign In
                    </Button>
                  )}
                </div>
              </Form>
            )}
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};
